import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7392c617"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frame-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-color" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frame-loading" }, null, -1))

import { onMounted, ref } from 'vue';
import { DEFAULT_DOMINANT_COLOR, DEFAULT_END_GRADIENT_COLOR } from '@/common/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'Frame',
  props: {
  noOverflow: {
    type: Boolean,
    required: false,
    default: false
  },
  full: {
    type: Boolean,
    required: false,
    default: false
  },
  hero: {
    type: Boolean,
    required: false,
    default: false
  },
  border: {
    type: Boolean,
    required: false,
    default: false
  },
  buffer: {
    type: Boolean,
    required: false,
    default: false
  },
  bigBuffer: {
    type: Boolean,
    required: false,
    default: false
  }
},
  setup(__props) {

const props = __props;



const hide = ref(true);

onMounted(async () => {
  window.addEventListener('load', async () => {
    hide.value = false;
  });
  // set background color
  if (document.readyState === 'complete') {
    hide.value = false;
  }
  hide.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["frame", {
             full: props.full,
             hero: props.hero,
             border: props.border,
             buffer: props.buffer,
             'big-buffer': props.bigBuffer,
             'no-overflow': props.noOverflow,
             hide: hide.value
           }])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      _hoisted_3
    ])
  ]))
}
}

})